// Author YuJiaBei
// Date 2021-01-19 14:37:04

class SithMesMstUserLocation {
constructor({
        id = null,
        userId = '',
        userIdName = '',
        mstLocationId = '',
        mstLocationName = '',
        remark = ''}
= {}) {
    this.id = id;
    this.userId = userId;
    this.userIdName = userIdName;
    this.mstLocationId = mstLocationId;
    this.mstLocationName = mstLocationName;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesMstUserLocation();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'userIdLoginName',
        label: 'label.sith.mst.sithMesMstUserLocation.grid.userIdLoginName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'userIdName',
        label: 'label.sith.mst.sithMesMstUserLocation.grid.userIdName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'mstLocationName',
        label: 'label.sith.mst.sithMesMstUserLocation.grid.mstLocationName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.mst.sithMesMstUserLocation.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    userIdFilter : "",
    userIdNameFilter : "",
    mstLocationIdFilter : "",
    mstLocationNameFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'userIdNameFilter',
        label: 'label.sith.mst.sithMesMstUserLocation.filter.userIdName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclUser'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"userId":"id"}'
                }
        },
        {
        key: 'mstLocationNameFilter',
        label: 'label.sith.mst.sithMesMstUserLocation.filter.mstLocationName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesMstLocation'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"mstLocationId":"id"}'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'userIdName',
        label: 'label.sith.mst.sithMesMstUserLocation.entity.userIdName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclUser'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"userId":"id"}'
                }
        },
        {
        key: 'mstLocationName',
        label: 'label.sith.mst.sithMesMstUserLocation.entity.mstLocationName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesMstLocation'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"mstLocationId":"id"}'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.mst.sithMesMstUserLocation.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesMstUserLocation, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
